import React from 'react';
import { percent } from "../../../helper/units.js";
import styles from "./SliderRange.module.js";
import { jsx as _jsx } from "react/jsx-runtime";
export function SliderRange({
  stops,
  maxRange,
  minValue,
  stopMax,
  stopMin
}) {
  const [beg, end] = stops.length === 1 ? [0, stopMax - minValue] : [stopMin - minValue, stopMax - minValue];
  return /*#__PURE__*/_jsx("div", {
    className: styles.range,
    style: {
      width: percent((end - beg) / maxRange),
      left: percent(beg / maxRange)
    }
  });
}